import {AfterViewInit, Component, Inject, Input, OnDestroy, OnInit} from '@angular/core';
import {PasoWizard} from "../../interface/wizard-informacion.types";
import {FormControl, FormGroup} from "@angular/forms";
import {WIZARD_DATA} from "../../tokens/tokens";
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {ButtonControlService} from '../../services/button-control.service';
import {EvkSeccionModel} from '../../../expediente/models/evk-seccion.model';
import {MatSnackBar} from '@angular/material/snack-bar';
import {DatosSeccionWizardEventsService} from "../../services/datos-seccion-wizard-events.service";
import {WizardEventsService} from "../../services/wizard-events.service";
import {ActionField} from "@evomatik/evk-forms";

@Component({
    selector: 'lib-sub-container',
    templateUrl: './section.component.html',
    styleUrls: ['./section.component.css']
})
export class SectionComponent implements OnInit, AfterViewInit, OnDestroy {

    form: FormGroup = new FormGroup({});

    private _unsubscribeAll: Subject<any>;

    paso: PasoWizard;

    @Input()
    biosphereConfig: any;

    @Input()
    descargaZipByFolio: boolean;

    @Input()
    skipByVersion: boolean;

    idWizard: string;

    readOnly;

    valorAlmacenado;
    listaAlmacenada = [];
    doneForm: Subject<boolean> = new Subject<boolean>();

    actionsField: ActionField[] = [];

    constructor(
        @Inject(WIZARD_DATA) public data: any,
        private buttonControlService: ButtonControlService,
        public datosSeccionWizard: DatosSeccionWizardEventsService,
        private _snackBar: MatSnackBar,
        private wizardEventsService: WizardEventsService
    ) {
        this._unsubscribeAll = new Subject();
        this.paso = data.paso;
        this.idWizard = data.idWizard;
        this.readOnly = data.readOnly;
        this.biosphereConfig = data.biosphereConfig;
        this.descargaZipByFolio = data.descargaZipByFolio;
        this.skipByVersion = data.skipByVersion;
        this.actionsField.push({name: "convertToUpperCase", accion: this.convertToUpperCase, params: {}});
        this.actionsField.push({name: "convertToLowerCase", accion: this.convertToLowerCase, params: {}});
        this.actionsField.push({name: "copyFirstSixCharacters", accion: this.copyFirstSixCharacters, params: {form: this.form, searchControl: this.searchControl}});
    }

    ngOnInit(): void {
        if (this.readOnly) {
            this.buttonControlService.cambiarBotonSiguiente(true);
        } else {
            if (this.paso.ui == 'metadata' || this.paso.ui == 'general') {
                if (this.paso.cardinalidad === '*') {
                    if (this.paso.inData && this.paso.inData.informacion && this.paso.inData.informacion.length > 0) {
                        this.buttonControlService.cambiarBotonSiguiente(true);
                    }
                } else {
                    this.form.valueChanges.pipe(takeUntil(this._unsubscribeAll)).subscribe(value => {
                        this.buttonControlService.cambiarBotonSiguiente(this.form.valid);
                        if (this.form.valid) {
                            this.onSelectionChanged(value);
                        }
                    });
                }
            }
        }
    }

    onSelectionChanged(data, save?: boolean) {
        const response: EvkSeccionModel = {
            origen: this.paso.nombre,
            propiedades: data
        }
        if (save) {
            this.datosSeccionWizard.onDoneSave.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
                this.wizardEventsService.save();
            })
        }
        this.datosSeccionWizard.doneSave(response);
    }

    isDetalle(val) {
        return val === 'detalle';
    }

    onSelectionChangedList(data: any[]) {
        const valor = {
            informacion: data
        }
        this.buttonControlService.cambiarBotonSiguiente(valor.informacion.length > 0);
        this.onSelectionChanged(valor, true);
    }

    ngAfterViewInit() {
        this.validarInformacion();
    }

    validarInformacion() {
        if (this.paso.inData) {
            if (this.paso.ui === 'metadata' || this.paso.ui === 'general') {
                if (this.paso?.cardinalidad === '*') {
                    this.listaAlmacenada = this.paso.inData != null && this.paso.inData.informacion != null ? this.paso.inData.informacion : [];
                } else {
                    this.doneForm.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
                        setTimeout(() => {
                            this.form.patchValue(this.paso.inData);
                            if (this.readOnly) {
                                this.form.disable();
                            }
                        });
                    });
                }
            } else if (this.paso.ui === 'persona') {
                this.valorAlmacenado = this.paso.inData.id != null ? this.paso.inData.id : null;
            } else if (this.paso.ui === 'estimulos' || this.paso.ui === 'evaluaciones') {
                this.listaAlmacenada = this.paso.inData != null && this.paso.inData.informacion != null ? this.paso.inData.informacion : [];
            }
        } else {
            this.valorAlmacenado = null;
            this.listaAlmacenada = [];
        }
    }

    onDoneForm(value: boolean) {
        this.doneForm.next(value);
    }

    validarAdjuntando(event: boolean) {
        this.buttonControlService.cambiarBotonSiguiente(event);
    }

    convertToUpperCase(params: {}) {
        const formControl = params['formControl'] as FormControl;
        if (formControl.value) {
            formControl.setValue(formControl.value.toUpperCase());
        }
    }
    convertToLowerCase(params: {}) {
        const formControl = params['formControl'] as FormControl;
        if (formControl.value) {
            formControl.setValue(formControl.value.toLowerCase());
        }
    }

    copyFirstSixCharacters(params: {}) {
        const controlCurp = params['formControl'] as FormControl;
        const controlRfc = params['searchControl'](params['form'], 'rfc') as FormControl;

        if (controlCurp && controlRfc && !controlRfc.value && controlCurp.value) {
            controlRfc.setValue(controlCurp.value.toString().substring(0, 10));
        }

    }

    searchControl(formGroup: FormGroup, nombreControl: string): FormControl | null {
        if (formGroup.controls[nombreControl]) {
            return formGroup.controls[nombreControl] as FormControl;
        }
        for (const control in formGroup.controls) {
            if (formGroup.controls[control] instanceof FormGroup) {
                const resultado = this.searchControl(formGroup.controls[control] as FormGroup, nombreControl);
                if (resultado) {
                    return resultado;
                }
            }
        }
        return null;
    }

    ngOnDestroy() {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
        this._unsubscribeAll.unsubscribe();
    }
}
